import styled from 'styled-components';

export const Option = styled.div<{ selected: boolean }>`
  padding: 4px 16px;
  height: 25px;
  color: ${(props) => (props.selected ? '#FFFFFF' : '#464AC9')};
  background: ${(props) => (props.selected ? '#464AC9' : '#f4f5ff')};
  border: 1px solid #464ac9;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
`;
